import {
  ChangeDetectionStrategy,
  Component,
  HostListener,
} from '@angular/core';

@Component({
  selector: 'app-scroll-top-button',
  templateUrl: './scroll-top-button.component.html',
  styleUrls: ['./scroll-top-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ScrollTopButtonComponent {
  readonly SCROLL_TOP_BTN_ID = 'scroll-top-button1';
  readonly SCROLL_TOP_HEIGHT = 60;

  scrollTop() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  }

  @HostListener('window:scroll', ['$event'])
  onScroll() {
    const button = document.getElementById(this.SCROLL_TOP_BTN_ID);
    if (
      document.body.scrollTop > this.SCROLL_TOP_HEIGHT ||
      document.documentElement.scrollTop > this.SCROLL_TOP_HEIGHT
    ) {
      button.style.opacity = '1';
    } else {
      button.style.opacity = '0';
    }
  }
}
